module.exports = __webpack_public_path__ + "static/media/Events-05.a94e0afd.webp";